import { render, staticRenderFns } from "./BillboardList.vue?vue&type=template&id=54bc10b2"
import script from "./BillboardList.vue?vue&type=script&lang=js"
export * from "./BillboardList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports